module.exports = __webpack_public_path__ + "img/bg-disponible.a8a70c57.png";